import React from 'react'
import { useTranslation } from 'react-i18next'

import { Flex } from '../../Common/Flex'
import { Row } from '../../Common/Grid'
import { Package } from '../Components/Package/Package'
import { planArray } from '../data/plans'

import { StyledTitle } from './style'

export const PlanSelect = () => {
  const { t } = useTranslation()
  return (
    <Flex
      flexWrap={'wrap'}
      alignContent={'center'}
      flexDirection={'column'}
      justifyContent={'center'}>
      <StyledTitle padding={'30px 0'}>{t('Pick  your plan.')}</StyledTitle>
      <Row width={'100%'} justifyContent={'center'}>
        {planArray.map(plan => (
          <Package key={plan.title} plan={plan} />
        ))}
      </Row>
    </Flex>
  )
}
